import React from 'react';
import LeaveUploadTable from '../../setup-leave-approval/leave-upload-table';

const LeaveApproveTable = () => {
	return <LeaveUploadTable {...{ isleaveApproveUpload: true, leavePath: '/leaves/leaves_to_approve' }} />;
};

export default LeaveApproveTable;
